import { render } from "./MainBoard.vue?vue&type=template&id=63169992&scoped=true"
import script from "./MainBoard.vue?vue&type=script&lang=js"
export * from "./MainBoard.vue?vue&type=script&lang=js"

import "./MainBoard.vue?vue&type=style&index=0&id=63169992&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63169992"]])

export default __exports__